import React from 'react';
import { useStepsContext } from '../StepsContext';
import { StepWrapper } from '../steps/StepWrapper';
import { InitialStep } from '../steps/InitialStep';
import { EmailIdentificationStep } from '../steps/EmailIdentificationStep';
import { BusinessInfoStep } from '../steps/BusinessInfoStep';
import { ChangeEmailStep } from '../steps/ChangeEmailStep';
import { ProfileSetupStep } from '../steps/ProfileSetupStep';
import { CodeActivationStep } from '../steps/CodeActivationStep';
import { ResetPasswordStep } from '../steps/ResetPasswordStep';
import { SocialFallbackStep } from '../steps/SocialFallbackStep';
import { LazyInvitationStep } from '../steps/InvitationStep';

export const ActiveStep = () => {
    const { activeStepId } = useStepsContext();

    switch (activeStepId) {
        case 'initial':
            return (
                <StepWrapper>
                    <InitialStep />
                </StepWrapper>
            );
        case 'email_identification':
            return (
                <StepWrapper showDisclaimer>
                    <EmailIdentificationStep />
                </StepWrapper>
            );
        case 'profile_setup':
            return (
                <>
                    <StepWrapper>
                        <ProfileSetupStep />
                    </StepWrapper>
                    <BusinessInfoStep.PreloadView />
                </>
            );
        case 'business_info':
            return (
                <StepWrapper hideCloseBtn>
                    <BusinessInfoStep />
                </StepWrapper>
            );
        case 'invitation':
            return (
                <StepWrapper hideCloseBtn>
                    <LazyInvitationStep />
                </StepWrapper>
            );
        case 'code_activation':
            return (
                <StepWrapper hideCloseBtn>
                    <CodeActivationStep />
                </StepWrapper>
            );
        case 'change_email':
            return (
                <StepWrapper>
                    <ChangeEmailStep />
                </StepWrapper>
            );
        case 'reset_password':
            return (
                <StepWrapper>
                    <ResetPasswordStep />
                </StepWrapper>
            );
        case 'social_fallback':
            return (
                <StepWrapper showDisclaimer>
                    <SocialFallbackStep />
                </StepWrapper>
            );
        default:
            return null;
    }
};
